import { render, staticRenderFns } from "./sub_order_detail.vue?vue&type=template&id=1a02e084&scoped=true"
import script from "./sub_order_detail.vue?vue&type=script&lang=js"
export * from "./sub_order_detail.vue?vue&type=script&lang=js"
import style0 from "./sub_order_detail.vue?vue&type=style&index=0&id=1a02e084&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a02e084",
  null
  
)

export default component.exports